import type { RouteLocationNamedRaw } from 'vue-router'

import router from '@/app/router'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { getChatRoute, type ChatRouteSource } from '@/shared/utils/url'

const mainRoute: RouteLocationNamedRaw = { name: pathNames.MAIN }

export const navigateFromEndedCall = (room?: ChatRouteSource | null) => {
  const chatRoute = room ? getChatRoute(room) : undefined
  if (chatRoute && resolveChatMessagingUiEnabled()) {
    return router.push(chatRoute)
  }

  return router.push(mainRoute)
}

export const leaveCallSessionRouteIfCurrent = (sessionId: string) => {
  const { name, params } = router.currentRoute.value
  if (params.sessionId !== sessionId) {
    return Promise.resolve()
  }

  if (name === pathNames.CALL_SESSION) {
    return router.push(mainRoute)
  }

  if (name === pathNames.GUEST_CALL_SESSION) {
    return Promise.resolve(router.back())
  }

  return Promise.resolve()
}
